import { useEffect, useState } from 'react';

/** Matches Tailwind `md` breakpoint — layout tweaks for phones / narrow viewports. */
const MOBILE_MQ = '(max-width: 767px)';

/**
 * Returns whether the viewport matches the mobile breakpoint (`max-width: 767px`).
 */
export function useMobileLayout(): boolean {
  const [isMobile, setIsMobile] = useState(false);

  useEffect(() => {
    const mq = window.matchMedia(MOBILE_MQ);
    const sync = () => setIsMobile(mq.matches);
    sync();
    mq.addEventListener('change', sync);
    return () => mq.removeEventListener('change', sync);
  }, []);

  return isMobile;
}
